// ============================================================================
// L'IDENTITÉ D'UNE CAISSE À L'ÉCRAN — comment un `register_id` scellé se donne à lire.
//
// ⚠️ REMONTÉ DU BACK-OFFICE À LA RÈGLE DE 2 « TOUTES APPS » (2026-09-07) : la Console affiche les
// mêmes numéros dans sa supervision et sa fiche magasin. Recopiée, la règle aurait fini par rendre
// « R01 » d'un côté et « 1 » de l'autre pour la MÊME caisse — et un lecteur y verrait deux caisses.
// C'est exactement ce qui était arrivé à l'intérieur du back-office avant son extraction, et ce qui
// venait de recommencer entre les deux applications (retour utilisateur : « partout on doit avoir
// R01, pas juste 01 »).
//
// ⚠️ LA TABLETTE N'EST PAS CONCERNÉE : elle porte sa propre normalisation
// (`register-identity.ts`), parce qu'elle NÉGOCIE ce numéro à l'appairage au lieu de simplement
// l'afficher. Deux besoins distincts, deux fonctions — les confondre ferait dépendre une caisse
// React Native d'un paquet web.
// ============================================================================

/**
 * LE CODE DE CAISSE TEL QU'IL S'AFFICHE — « 1 » devient « R01 », comme la maquette.
 *
 * ⚠️ RENDU SEULEMENT, JAMAIS STOCKÉ. Le `register_id` scellé est le code COURT (entier ≥ 1) qui
 * compose le numéro de pièce `T-S<magasin>R<caisse>-…` (§30.7.1) ; une fois la première pièce signée,
 * il devient un **paramètre fiscal FIGÉ** (§12.6). Le repadder en base réécrirait l'identité d'une
 * caisse en service — ici on ne fait que l'afficher comme la maquette l'écrit.
 *
 * ⚠️ CE QUI N'EST PAS UN ENTIER RESTE INTACT : « LEGACY-C1 », posé par la reprise, n'est pas un numéro
 * de caisse mais une sentinelle qui distingue l'historique repris des pièces nées en caisse. Le
 * travestir en « R01 » effacerait exactement cette distinction.
 */
export function codeCaisse(id: string): string {
  return /^\d+$/.test(id) ? `R${id.padStart(2, '0')}` : id;
}
